module.exports = __webpack_public_path__ + "img/210.56b3e80a.jpg";